import Session from "@lib/session";
import FrameConfig from "@lib/classes/FrameConfig";
import { useExtrasQuery, ExtrasDocument } from "@graphql/api";

const variables = (serviceArea?: number, serviceExtrasAlias?: string) => ({
  groupProfile: Session.getBooking().profiles.group,
  serviceArea: serviceArea || Session.getBooking().serviceArea,
  serviceExtrasAlias:
    serviceExtrasAlias === undefined
      ? Session.getCurrentLeg().service?.serviceExtrasAlias
      : serviceExtrasAlias,
});

export async function getServiceExtras() {
  return await global.window.apolloClient.query({ query: ExtrasDocument });
}

function useServiceExtras(serviceArea?: number, serviceExtrasAlias?: string) {
  return useExtrasQuery({ variables: variables(serviceArea, serviceExtrasAlias) });
}

export default useServiceExtras;
